// ------------------------------------
// Constants
// ------------------------------------
export const initialState: State.ExemptionReference = {
  exempReference: [],
  exemptReferenceFetched: false,
  exemptReferenceFrontloadRequest: false,
  workExperienceDataFetched: false,
};
